import React from 'react';
import './AboutProductsSection.css';

const productBlocks = [
  {
    icon: '/icons/atom.webp',
    title: 'DRIVING DIGITAL TRANSFORMATION',
    description: 'Since our inception in May 2020, Lattice labs has scaled over 300 digital products across Europe, the United States, and the Middle East. We are committed to transforming how digital products are built by prioritising the user\'s experience and leveraging our technical expertise.',
    highlights: ['May 2010', '300 digital products', 'user\'s experience']
  },
  {
    icon: '/icons/rocket.webp',
    title: 'PARTNERING FOR SUCCESS',
    description: 'At Lattice Labs, we offer more than software solutions; we provide strategic partnerships. Our elite delivery processes and deep vertical expertise ensure that every solution surpasses modern digital transformation needs. By collaborating closely with your team, our expert consultants deliver faster, better, and scalable results to strengthen your competitive edge in a rapidly evolving market.',
    highlights: ['strategic partnerships', 'vertical expertise', 'faster, better, and scalable results']
  },
  {
    icon: '/icons/innovation.webp',
    title: 'INNOVATION AT THE CORE',
    description: 'Our user-centric and agile methodologies are designed to seamlessly integrate into your workflows, allowing us to address your specific needs and ensure effective user adoption. We don\'t just build software; we build solutions that propel your business forward.',
    highlights: ['user-centric and agile methodologies', 'propel your business forward']
  }
];

const AboutProductsSection = () => {
  const highlightText = (text, highlights) => {
    let highlightedText = text;
    highlights.forEach(highlight => {
      const regex = new RegExp(`(${highlight})`, 'gi');
      highlightedText = highlightedText.replace(regex, '<span class="highlight">$1</span>');
    });
    return highlightedText;
  };

  return (
    <section className="aboutproducts-section" id="aboutproducts">
      <div className="container">
      <div className="aboutproducts-content-wrapper">
        {/* Main Heading */}
        <div className="aboutproducts-main-heading">
          <h1>CHANGING HOW DIGITAL PRODUCTS ARE BUILT</h1>
        </div>

        {/* Three Content Blocks */}
        <div className="aboutproducts-blocks-container">
          {productBlocks.map((block, idx) => (
            <div className="aboutproducts-block" key={idx}>
              <div className="aboutproducts-icon">
  <img src={block.icon} alt={block.title + ' icon'} />
</div>
              <h2 className="aboutproducts-block-title">{block.title}</h2>
              <p 
                className="aboutproducts-block-description"
                dangerouslySetInnerHTML={{ 
                  __html: highlightText(block.description, block.highlights) 
                }}
              ></p>
            </div>
          ))}
        </div>

        {/* Call to Action Section */}
        <div className="aboutproducts-cta-section">
          <h2 className="aboutproducts-cta-heading">
            DON'T JUST TAKE OUR WORD FOR IT! TAKE A LOOK AT OUR REVIEWS, CLIENTS, AND AWARDS
          </h2>
          <p 
            className="aboutproducts-cta-description"
            dangerouslySetInnerHTML={{ 
              __html: highlightText(
                'We pride ourselves on building strong partnerships built on transparency, trust, and cooperation. You can expect a partner with strong worth ethics, entirely focused on problem-solving and on building long-term engagements. That is why many of our customers stay with us for longer than two years.',
                ['building strong partnerships', 'transparency, trust, and cooperation']
              ) 
            }}
          ></p>
        </div>
      </div>
      </div>
    </section>
  );
};

export default AboutProductsSection;